var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62924 10C9.53476 10 9.44028 9.96403 9.36835 9.89185L0.108094 0.62988C-0.0360314 0.485756 -0.0360314 0.252218 0.108094 0.108093C0.25222 -0.0360311 0.485759 -0.0360311 0.629631 0.108093L9.88963 9.37031C10.0338 9.51444 10.0338 9.74797 9.88963 9.8921C9.81795 9.96378 9.72347 10 9.62924 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.368989 10C0.27451 10 0.180283 9.96403 0.108094 9.8921C-0.0360314 9.74797 -0.0360314 9.51444 0.108094 9.37031L9.37037 0.108093C9.5145 -0.0360311 9.74778 -0.0360311 9.89191 0.108093C10.036 0.252218 10.036 0.485756 9.89191 0.62988L0.629631 9.8921C0.557694 9.96378 0.463469 10 0.368989 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.6be42efab8a1f4f70d2a70c772908138.svg";
export { ForwardRef as ReactComponent };